import React from "react";
import { X } from "lucide-react";
import { useEmailHistory, removeEmail } from "@/lib/emailHistory";

/**
 * Recipients text input with suggestion chips fed by localStorage history.
 * Clicking a suggestion appends it to the current comma-separated value.
 * Each chip has an X icon to permanently remove that address from history.
 *
 * Props: value (string), onChange (str => void), placeholder (str).
 */
export default function RecipientsField({ value, onChange, placeholder, testIdPrefix }) {
  const history = useEmailHistory();
  const current = new Set(
    value.split(/[,;\s]+/).map(s => s.trim().toLowerCase()).filter(Boolean)
  );
  const suggestions = history.filter(e => !current.has(e));

  const addChip = (email) => {
    const cur = value.trim();
    const sep = cur && !cur.endsWith(",") ? ", " : "";
    onChange(cur + sep + email);
  };

  return (
    <div>
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || "mario@example.com, laboratorio@lab.it"}
        className="input-luxury text-sm w-full"
        data-testid={`${testIdPrefix || "email"}-recipients`}
      />
      {suggestions.length > 0 && (
        <div className="mt-2">
          <div className="text-[10px] tracking-luxury uppercase text-[#707070] mb-1.5">
            Indirizzi recenti
          </div>
          <div className="flex flex-wrap gap-1.5" data-testid={`${testIdPrefix || "email"}-history`}>
            {suggestions.slice(0, 12).map(email => (
              <span key={email}
                     className="inline-flex items-center gap-1 px-2 py-1 border border-[#E5E5E0] rounded-sm text-xs bg-[#FAFAF7] hover:border-[#C5B39B] group">
                <button type="button" onClick={() => addChip(email)}
                         className="text-[#4A4A4A] hover:text-[#1A1A1A]"
                         data-testid={`${testIdPrefix || "email"}-suggest-${email}`}>
                  {email}
                </button>
                <button type="button"
                         onClick={(e) => { e.stopPropagation(); removeEmail(email); }}
                         className="text-[#8A8579] hover:text-[#8C3A3A] opacity-60 group-hover:opacity-100"
                         title="Rimuovi dalla cronologia"
                         data-testid={`${testIdPrefix || "email"}-remove-${email}`}>
                  <X className="w-2.5 h-2.5" strokeWidth={2} />
                </button>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
